const REGEX_PATTERNS = {
  latlng: /^(-?\d+\.\d+),(-?\d+\.\d+),(-?\d+)+o$/,
}

export const isLatLngQueryString = (path) => REGEX_PATTERNS["latlng"].test(path)

export const createGeolocationFeature = (path, properties = {}) => {
  try {
    const [id, latitude, longtitude, ordinal] = path.match(
      REGEX_PATTERNS["latlng"]
    )
    return {
      type: "Feature",
      feature_type: "geolocation",
      id,
      geometry: {
        type: "Point",
        coordinates: [parseFloat(latitude), parseFloat(longtitude)],
      },
      properties: {
        ordinal: parseInt(ordinal),
        userLocationParam: path,
        queryString: `?user-location=${path}`,
        ...properties,
      },
    }
  } catch (error) {
    return null
  }
}
